<template>
  <div class="profile-input-wrapper">
    <label class="toggle">
      <input
        type="checkbox"
        name="sustainability-preference"
        class="is-sr-only"
        :checked="enableSwitcher"
        @change="handleChange($event.target.checked)"
      >
      <span class="toggle__slider round" />
    </label>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    // eslint-disable-next-line vue/component-definition-name-casing
    name: 'profile-sustainability-preference-input',
    props: {
      value: {
        type: String,
        required: true
      },
      endpoint: {
        type: String,
        required: false,
        default: 'sustainablestay'
      },
      method: {
        type: String,
        required: false,
        default: 'PATCH'
      }
    },
    computed: {
      ...mapState('auth', ['user']),

      enableSwitcher() {
        return this.user && this.user.otherPreferences
          ?.find((preference) => preference === this.value)
      }
    },
    methods: {
      ...mapActions('auth', ['updateProfile']),

      async handleChange(checked) {
        await this.updateProfile({
          data: {
            sustainabilityPreference: checked,
            value: this.value
          },
          endpoint: this.endpoint,
          method: this.method.toLowerCase()
        })
      }
    }
  }
</script>
